import {ApiClientService, EntityApiService} from '@dofleini/security';

import {authentication} from '@/settings';

class ProposalRequestApiService extends EntityApiService {
  checkPartner = (params) => {
    return ApiClientService.post(this.getPath('/check-partner'), params);
  }

  updateCheckListItem = ({proposalId, id, ...rest}) => {
    return ApiClientService.post(this.getPath(`/verify/${proposalId}/checklist/${id}`), rest);
  }

  partnerVerify = (id, params) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/partner-confirm`), params);
  }

  partnerReject = (id, params) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/partner-reject`), params);
  }

  existIdentifier = (params) => {
    return ApiClientService.post(this.getPath('/exist-identifier'), params);
  }

  searchPrioritizedAreas = (params, config) => {
    return ApiClientService.post(
      `${this.getPath('/prioritized-areas/search', params)}`,
      params,
      config
    );
  }

  searchReduced = (params) => {
    return ApiClientService.post(this.getPath('/searchReduced'), params);
  }

  searchValidatedReduced = (params) => {
    return ApiClientService.post(this.getPath('/searchValidatedReduced'), params);
  }

  exportExcel = async (params) => {
    return ApiClientService.post(this.getPath('/export?format=excel'), params);
  }

  updateCertificationAval = async (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/upload-certification`, params), params, config);
  }

  downloadPDFCertificationAval = async (params) => {
    ApiClientService.pushDefaultHeader('Accept', 'application/pdf');
    const response = await ApiClientService.get(this.getPath(`/print/${params._id}`), {responseType: 'arraybuffer'});
    const type = response.headers['content-type'];
    // eslint-disable-next-line no-undef
    const blob = new Blob([response.data], {type: type, encoding: 'UTF-8'});
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `${params.pdfName}.pdf`;
    link.click();
  }

  downloadAdminGroupVerification = async (params) => {
    ApiClientService.pushDefaultHeader('Accept', 'application/json');
    const response = await ApiClientService.post(this.getPath('/administrationControl/aggregation'), params, {responseType: 'arraybuffer'});
    // eslint-disable-next-line no-undef
    const blob = new Blob([response.data], {type: 'json', encoding: 'UTF-8'});
    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = `verify-admin-group-${new Date().toDateString()}.json`;
    link.click();
  }

  count = (params) => {
    return ApiClientService.post(this.getPath('/count'), params);
  }

  countByPrioritizedAreas = (params) => {
    return ApiClientService.post(this.getPath('/prioritized-areas/count'), params);
  }

  getOneReduced = (id, config) => {
    return ApiClientService.get(this.getPath(`/${id}/reduced`, config), config);
  }

  getOneNotaryProposal = ({proposalId}) => ApiClientService.get(this.getPath(`/notary/${proposalId}`))

  updateStatutesFile = async (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/update-statutes`, params), params, config);
  }

  assignResponsible = async (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/assign-responsible`, params), params, config);
  }

  updateRepresentative = async ({id, idNumber, partners}, config) => {
    const params = partners?.map((e) => ({...e, representative: e?.idNumber === idNumber}));
    return ApiClientService.patch(this.getPath(`/${id}`, {partners: params}), {partners: params}, config);
  }

  updateProposalNotary = async (id, params, config) => {
    if (typeof id === 'object') {
      params = id;
      id = id.id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/notary-edit`, params), params, config);
  }

  checkToCIBankProcess = async (id, params, config) => {
    return ApiClientService.patch(this.getPath(`/${id}/check-to-bank-ci`, params), params, config);
  }

  getRelatedByName = async (id, params, config) => {
    return ApiClientService.get(this.getPath(`/related-names/${id}`, params), params, config);
  }

  aggregate = async (key = 'skinColor', params, config) => {
    return ApiClientService.post(this.getPath(`/${key}/aggregation`, params), params, config);
  }

  updateManyStatus = async (params, config) => {
    return ApiClientService.post(this.getPath('/status', params), params, config);
  }

  getOneByCode = async (id, config) => {
    return ApiClientService.get(this.getPath(`/${id}/code`, config), config);
  };

  searchOld = (params, config) => {
    return ApiClientService.post(this.getPath('/search_old'), params, config);
  }

  searchAll = (params, config) => {
    return ApiClientService.post(this.getPath('/search_all'), params, config);
  }
  
  searchMyProposals = (params, config) => {
    return ApiClientService.post(this.getPath('/my-proposals'), params, config);
  }
}

export default new ProposalRequestApiService(`${authentication.path}/api/proposal-requests`);
